"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StaffRefSchema = exports.CursorQuerySchema = void 0;
exports.pageSchema = pageSchema;
const zod_1 = require("zod");
/** Opaque cursor pagination used by every admin list endpoint. */
exports.CursorQuerySchema = zod_1.z.object({
    cursor: zod_1.z.string().min(1).max(512).optional(),
    limit: zod_1.z.coerce.number().int().min(1).max(100).default(50),
});
function pageSchema(item) {
    return zod_1.z.object({ items: zod_1.z.array(item), nextCursor: zod_1.z.string().nullable() });
}
/** `{ id, name }` of a staff member, the way lists and details name one. */
exports.StaffRefSchema = zod_1.z.object({ id: zod_1.z.uuid(), name: zod_1.z.string() });
//# sourceMappingURL=common.js.map